import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import * as Yup from 'yup';
import { FormatText, FormSelect, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';
import { getAllStatusOrdemCompraExibicaoOptions, getAllStatusOrdemCompraOptions } from '@app/api/status';
import { atualizarStatusOrdemCompra } from '@app/api/sas/ordemCompra';


const ModalAtualizarStatusOrdem = ({ ordemCompraId, exibirModal, setExibirModal }: any) => {

    const onCancel = () => {
        setExibirModal(false);
    };

    const onSubmit = (values: any) => {
        atualizarStatusOrdemCompra({ ...values, ordemCompraId }).then(_ => {
            setExibirModal(false);
            window.location.reload();
        })
    };

    return (
        <>

            <Modal
                title="Atualizar Status Ordem de Compra"
                visible={exibirModal}
                onCancel={() => onCancel()}
                footer={null}
                width="780px">
                {exibirModal && (
                    <MasterDetailForm
                        key="formAprovacaoProponentesGerente"
                        onSubmit={onSubmit}
                        validationSchema={Yup.object().shape({
                            justificativa: Yup.string()
                                .required('Justificativa deve ser informado.'),
                            statusOrdemCompraId: Yup.string()
                                .required('Selecione um status.'),
                            statusOrdemCompraExibicaoId: Yup.string()
                                .required('Selecione um status de exibição.'),
                        })}
                        actions={[
                            <FormSubmitButton noIcon type="primary">
                                <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>,
                        ]}>

                        <FormSelect name="statusOrdemCompraId" label="Status" span={12} getOptions={getAllStatusOrdemCompraOptions} />
                        <FormSelect name="statusOrdemCompraExibicaoId" label="Status de Exibição" span={12} getOptions={getAllStatusOrdemCompraExibicaoOptions} />
                        <FormTextArea name="justificativa" label="Justificativa" span={12} rows={4} />

                    </MasterDetailForm>
                )}
            </Modal>
        </>
    );
};

export default ModalAtualizarStatusOrdem;